import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// manor
import { Link } from '@comparethemarketau/manor-link';
import { withQuoteFlatten } from './with_quote_flatten';

const _IsThisProductSuitableForMe = (props) => {
    const { productId, className, productSuitability, children } = props;

    return (
        <div data-product-id={productId} className={classNames(className)}>
            <Link
                trackingLabel={`Product suitability for productId: ${productId}`}
                underline="none"
                target="_blank"
                href={productSuitability}
            >
                {children || 'Is this product suitable for me?'}
            </Link>
        </div>
    );
};

_IsThisProductSuitableForMe.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    quote: PropTypes.object,
    productId: PropTypes.string,
    productSuitability: PropTypes.string
};

const IsThisProductSuitableForMe = withQuoteFlatten(_IsThisProductSuitableForMe);

export { IsThisProductSuitableForMe };
